<script setup>
import SubscriptionForm from '@/components/subscription/SubscriptionForm.vue'
</script>

<template>
  <subscription-form />
</template>
